import { AccountFeatures, AppContext } from "@lightspeed-invoicing/core-client/frontend"
import React, { Component } from 'react'
import { FormattedMessage, FormattedNumber, defineMessages, injectIntl } from 'react-intl'
import { Link } from "react-router-dom"
import GlobalHelper from "../../common/GlobalHelper.jsx"
import { StatusBadge } from "../../common/badge"
import Icon from "../../common/icon/icon.component.jsx"
import InlineEditAddress from "../../common/inline-edit/address.component.jsx"
import InlineEditAgenda from "../../common/inline-edit/agenda.component.jsx"
import InlineEditDate from '../../common/inline-edit/date.component.jsx'
import InlineEditLocation from "../../common/inline-edit/location.component.jsx"
import InlineEditSlider from "../../common/inline-edit/slider.component.jsx"
import InlineEditText from "../../common/inline-edit/text.component.jsx"
import InlineEditUser from "../../common/inline-edit/user.component.jsx"
import LoadingSpinner from "../../common/spinner/loading.component.jsx"
import CustomFieldRendering from '../../custom-field/rendering.component.jsx'
import Integrations from "../../integration/Integrations.jsx"
import CreditMemoModalLink from '../../invoice/creditmemomodallink.component'
import InvoiceDueDate from "../../invoice/duedate.component.jsx"
import InvoicePaymentTerm from '../../invoice/paymentterm.component.jsx'
import InvoiceStatusBadge from "../../invoice/status.component.jsx"
import { getPriceListName } from '../../name-helpers/priceListNameHelper'
import OrderStatusBadge from "../../order/status.component.jsx"
import EditProjectTitleComponent from '../../quote/project/component/EditProjectTitleComponent'
import QuoteStatusBadge from '../../quote/status.component.jsx'
import { BILLING_TYPE } from '../../state/invoice/InvoiceBillingType'
import { STOCK_DOCUMENTS } from "../../utils/inventory"
import ProjectCustomerEditForm from "./customerselectform.component.jsx"
import './details.scss'

const messages = defineMessages({
    "title_template": {
        id: 'quote.edit.project.title_template',
        defaultMessage: '{customerName} project',
    }
})

class ProjectDetailsEditForm extends Component {

    constructor(props, context) {
        super(props, context)
        let contact = null
        let contactId = ''
        let project = this.props.stockDocument
            ? this.props.stockDocument.project
            : this.props.project

        if (this.props.invoice && this.props.invoice.attributes.contact) {
            contact = this.props.invoice.attributes.contact
            contactId = contact.id
        } else if (this.props.order && this.props.order.attributes.contact) {
            contact = this.props.order.attributes.contact
            contactId = contact.id
        } else if (project?.attributes.contact) {
            contact = project.attributes.contact
            contactId = contact.id
        }

        this.state = {
            quote: this.props.quote || null,
            order: this.props.order || null,
            invoice: this.props.invoice || null,
            quotes: this.props.quotes || [],
            debtCreditMemo: null,
            invoices: this.props.invoices || [],
            externalPurchaseOrders: this.props.externalPurchaseOrders || [],
            //quote from which the invoice was created
            quoteReference: this.props.quoteReference || null,
            priceListReference: this.props.priceListReference || null,
            orderReference: this.props.orderReference || null,
            // recurring invoice from which the invoice was created
            recurringInvoice: this.props.recurringInvoice || null,
            //invoice from which the return was created
            relatedInvoice: this.props.relatedInvoice || null,
            project: project ?? null,
            initialContactId: this.props.initialContactId || '',
            contactId,
            contact,
            shipToContactId: project?.attributes?.shipToContactId ?? '',
            shipToFirstName: '',
            shipToLastName: '',
            shipToCompanyIdentifier: '',
            shipToStreet: '',
            shipToCity: '',
            shipToPostalCode: '',
            shipToStateCode: '',
            shipToCountryCode: '',
            customFieldValues: project?.attributes?.customFieldValues ?? {},
            customFieldDefinitions: [],
            isEditable: this.props.isEditable || false,
            showProjectCustomerEditForm: false,
            showLoyaltyBalance: this.props.showLoyaltyBalance || false,
            loyaltyBalance: '',
        }

        const defaultCallback = () => {
        }
        this.onChange = this.props.onChange || defaultCallback
        this.refreshObject = this.props.refreshObject || defaultCallback
        this.loadAnotherInvoice = this.props.loadAnotherInvoice || defaultCallback
        this.handleCustomerChanged = this.handleCustomerChanged.bind(this)
        this.onSaveInlineAddress = this.onSaveInlineAddress.bind(this)
        this.onSaveInLineLocation = this.onSaveInLineLocation.bind(this)
        this.changeCustomFieldValues = this.changeCustomFieldValues.bind(this)
        this.onSaveInLineUser = this.onSaveInLineUser.bind(this)
        this.getDocument = this.getDocument.bind(this)
        this.getDocumentId = this.getDocumentId.bind(this)
    }

    componentDidMount() {
        this.loadUser()
        this.loadDefinitions()
        if (this.state.invoice && this.state.invoice.attributes.debtCreditMemoID) {
            AppContext.getApiClient().get('/credit-memos/' + this.state.invoice.attributes.debtCreditMemoID).then(cm => {
                this.setState({
                    debtCreditMemo: cm,
                })
            })
        }
        if (this.state.showLoyaltyBalance && AppContext.hasFeatureIntegration(Features.LoyaltyRedemption)) {
            AppContext.getApiClient().get('/contacts/' + this.state.contactId + '/loyalty-customers').then(l => {
                this.setState({
                    loyaltyBalance: l.attributes.pointsBalance,
                })
            })
        }
    }

    componentWillReceiveProps(nextProps, nextContext) {
        let contact = null
        let contactId = ''
        const proj = nextProps.stockDocument ? nextProps.stockDocument.project : nextProps.project
        if (nextProps.invoice && nextProps.invoice.attributes.contact) {
            contact = nextProps.invoice.attributes.contact
            contactId = contact.id
        } else if (nextProps.order && nextProps.order.attributes) {
            contact = nextProps.order.attributes.contact
            contactId = contact.id
        } else if (proj?.attributes) {
            contact = proj.attributes.contact
            contactId = contact?.id ?? ""
        }
        this.setState({
            quote: nextProps.quote || null,
            order: nextProps.order || null,
            invoice: nextProps.invoice || null,
            quotes: nextProps.quotes || [],
            invoices: nextProps.invoices || [],
            externalPurchaseOrders: nextProps.externalPurchaseOrders || [],
            quoteReference: nextProps.quoteReference || null,
            orderReference: nextProps.orderReference || null,
            recurringInvoice: nextProps.recurringInvoice || null,
            relatedInvoice: nextProps.relatedInvoice || null,
            project: proj || null,
            customFieldValues: proj?.attributes?.customFieldValues ?? {},
            contactId,
            contact,
            shipToContactId: proj?.attributes?.shipToContactId ?? '',
            isEditable: nextProps.isEditable || false,
        }, () => {
            if (this.state.contact && !this.state.shipToContactId) {
                this.setState({
                    shipToFirstName: this.state.contact.attributes.shippingAddress.firstName,
                    shipToLastName: this.state.contact.attributes.shippingAddress.lastName,
                    shipToCompanyIdentifier: this.state.contact.attributes.organizationId,
                    shipToStreet: this.state.contact.attributes.shippingAddress.street,
                    shipToCity: this.state.contact.attributes.shippingAddress.city,
                    shipToPostalCode: this.state.contact.attributes.shippingAddress.postalCode,
                })
            }
        })
    }

    onSaveInlineAddress(state) {
        this.setState({
            shipToStreet: state.address.street,
            shipToCity: state.address.city,
            shipToPostalCode: state.address.postalCode,
            shipToCountryCode: state.address.countryCode,
            shipToStateCode: state.address.stateCode,
            shipToFirstName: state.firstName,
            shipToLastName: state.lastName,
            shipToCompanyIdentifier: state.companyId,
            shipToContactId: state.contactId,
        })
    }

    onSaveInLineLocation(objectType, state) {
        let object = Object.assign({}, this.state[objectType])
        object.attributes.locationId = state.locationId
        object.attributes.location.attributes.name = state.location
        this.setState({[objectType]: object})
    }

    onSaveInLineUser(objectType, state) {
        let object = Object.assign({}, this.state[objectType])
        let user = Object.assign({}, object.attributes.assignedToUser || object.attributes.seller)
        user.id = state.sellerId
        user.attributes.name = state.seller
        object.attributes.assignedToUser = user
        object.attributes.seller = user
        this.setState({[objectType]: object})
    }

    loadUser() {
        if (!this.state.assignToUser && this.state.assignToUserId) {
            AppContext.getApiClient().get('/users/' + this.state.assignToUserId).then(u => {
                this.setState({
                    assignToUser: u
                })
            })
        }
    }

    loadDefinitions() {
        AppContext.getApiClient().get('/custom-field-definitions').then(res => {
            let definitionsToApply = res.data.filter(def => {
                if (!def.attributes.availableFrom) {
                    return true
                }

                if (def.attributes.availableFrom?.includes(this.state.project.attributes.documentType)) {
                    return true
                }

                if (!this.state.project.attributes.documentType) {
                    return true
                }
                return def.attributes.availableFrom.includes(this.props.stockDocument?.definitionId) || false
            })
            this.setState({
                customFieldDefinitions: definitionsToApply,
            })
        })
    }

    changeCustomFieldValues(value, id) {
        let customFieldValues = Object.assign({}, this.state.customFieldValues)
        let project = Object.assign({}, this.state.project)
        customFieldValues[id] = value
        project.attributes.customFieldValues = customFieldValues
        this.setState({
            customFieldValues: customFieldValues,
            project: project
        })
    }


    handleCustomerChanged(contactId, customerName) {
        if (!contactId) {
            this.setState({
                showProjectCustomerEditForm: false,
            })
            return
        }

        let project = this.state.project
        if (!project.attributes.title) {
            project.attributes.title = this.props.intl.formatMessage(messages['title_template'], {
                customerName: customerName
            })
        }
        this.setState({
            contactId: contactId,
            project: project,
            initialContactId: '',
            showProjectCustomerEditForm: false,
        }, () => {
            this.onChange(this.getCurrentProject())
        })
    }

    getCurrentProject() {
        return {
            projectId: this.state.project.id,
            contactId: this.state.contactId,
        }
    }

    isRecurringInvoice() {
        return this.state.invoice && this.state.invoice.attributes.billingType === BILLING_TYPE.RECURRING
    }

    isReturn() {
        return this.state.invoice && this.state.invoice.attributes.billingType === BILLING_TYPE.RETURN
    }

    renderFieldColumn(colClass, labelFormattedMessage, value) {
        return <div className={'position-relative mt-2 px-1 text-break ' + colClass}>
            <div className={'py-1 px-2 h-100 inline-input'}>
                {labelFormattedMessage ?
                    <div>
                        <label className="col-form-label custom-form-label project-details-label pt-0">
                            {labelFormattedMessage}
                        </label>
                    </div> : ''
                }
                <div>
                    {value}
                </div>
            </div>
        </div>
    }

    renderFieldsByDocumentType() {
        if (this.state.quote) {
            return [
                <div className={'w-100 mt-2 p-2'} key={0}>
                    <div className={'w-100'}>
                        <label className="col-form-label custom-form-label project-details-label pt-2">
                            <strong>
                                <FormattedMessage
                                    id="project.form.edit.probability_label"
                                    defaultMessage="Probability to win"
                                />
                            </strong>
                        </label>
                    </div>
                    <div className={'w-100 d-flex align-items-center'}>
                        <div className={'px-2 flex-grow-1'}>
                            <InlineEditSlider
                                editable={this.state.isEditable}
                                endPoint={'/projects/' + this.state.project?.id}
                                field={'probability'}
                                valuePercent={this.state.project?.attributes.probability}
                                onSave={value => {
                                    let project = Object.assign({}, this.state.project)
                                    project.attributes.probability = value
                                    this.setState({project})
                                }}
                            />
                        </div>
                    </div>
                </div>,
                <div className="w-100 d-flex flex-wrap" key={1}>
                    {(this.state.quote.attributes.poNumber || this.state.isEditable) &&
                        this.renderFieldColumn(
                            'col-lg-3 col-md-4',
                            <FormattedMessage
                                id="quote.analytics.po_number_label"
                                defaultMessage="PO Number"
                            />,
                            <InlineEditText
                                editable={this.state.isEditable}
                                endPoint={'/projects/' + this.state.project?.id}
                                field={'poNumber'}
                                value={this.state.quote.attributes.poNumber}
                                onSave={value => {
                                    let quote = Object.assign({}, this.state.quote)
                                    quote.attributes.poNumber = value
                                    this.setState({quote})
                                }}
                            />
                        )
                    }

                    {
                        this.renderFieldColumn(
                            'col-lg-3 col-md-4',
                            <FormattedMessage
                                id="quote.analytics.expiration_date_label"
                                defaultMessage="Expiration date"
                            />,
                            <InlineEditDate
                                value={this.state.quote.attributes.expirationDate}
                                endPoint={'/quotes/' + this.state.quote.id}
                                field={'expirationDate'}
                                editable={this.state.isEditable}
                                onSave={value => {
                                    let quote = Object.assign({}, this.state.quote)
                                    quote.attributes.expirationDate = value
                                    this.setState({quote})
                                }}
                            />
                        )
                    }
                    {this.props.orders && this.props.orders.length > 0 && this.renderFieldColumn(
                        'col-lg-3 col-md-4',
                        <FormattedMessage
                            id="order.analytics.orders_reference_label"
                            defaultMessage="Orders"
                        />,
                        this.props.orders.map(ord => {
                            return <p key={ord.id} className={'mb-0'}>
                                <Link to={'/orders/' + ord.id + '/edit'}>
                                    {ord.attributes.identifier}
                                </Link>
                            </p>
                        }),
                    )}
                    {(this.state.quote.attributes.externalNotes || this.state.isEditable) &&
                        this.renderFieldColumn(
                            'col-lg-12 col-md-16',
                            <FormattedMessage
                                id="quote.analytics.notes_label"
                                defaultMessage="Notes"
                            />,
                            <InlineEditText
                                editable={this.state.isEditable}
                                endPoint={'/quotes/' + this.state.quote.id}
                                field={'externalNotes'}
                                multiLine={true}
                                value={this.state.quote.attributes.externalNotes}
                                onSave={value => {
                                    let quote = Object.assign({}, this.state.quote)
                                    quote.attributes.externalNotes = value
                                    this.setState({quote})
                                }}
                            />
                        )
                    }
                    {
                        <CustomFieldRendering
                            col={0}
                            customFieldValues={this.state.customFieldValues}
                            customFieldDefinitions={this.state.customFieldDefinitions}
                            isEditable={this.state.isEditable}
                            elementId={this.state.project?.id}
                            changeCustomFieldValues={this.changeCustomFieldValues}
                        />
                    }
                </div>,
            ]
        } else if (this.state.order) {
            return [
                <div className="w-100 d-flex flex-wrap" key={1}>
                    <EditProjectTitleComponent
                        editable={this.state.isEditable}
                        endPoint={'/projects/' + this.state.project?.id}
                        field={'title'}
                        value={this.state.order.attributes.project.attributes.title}
                        onSave={value => {
                            let order = Object.assign({}, this.state.order)
                            order.attributes.project.attributes.title = value
                            this.setState({order})
                        }}
                    />
                    {(this.state.order.attributes.poNumber || this.state.isEditable) &&
                        this.renderFieldColumn(
                            'col-lg-3 col-md-4',
                            <FormattedMessage
                                id="order.analytics.po_number_label"
                                defaultMessage="PO Number"
                            />,
                            <InlineEditText
                                editable={this.state.isEditable}
                                endPoint={'/orders/' + this.state.order.id}
                                field={'poNumber'}
                                value={this.state.order.attributes.poNumber}
                                onSave={(value) => {
                                    let order = Object.assign({}, this.state.order)
                                    order.attributes.poNumber = value
                                    this.setState({order})
                                }}
                            />
                        )}
                    {this.renderFieldColumn(
                        'col-lg-3 col-md-4',
                        <FormattedMessage
                            id="order.analytics.order_date_label"
                            defaultMessage="Order date"
                        />,
                        <InlineEditDate
                            value={this.state.order.attributes.orderedAt}
                            endPoint={'/orders/' + this.state.order.id}
                            field={'orderedAt'}
                            editable={this.state.isEditable}
                            onSave={value => {
                                let order = Object.assign({}, this.state.order)
                                order.attributes.orderedAt = value
                                this.setState({order})
                            }}
                            onChange={this.state.refreshObject}
                        />,
                    )}
                    {this.state.order.attributes.priceListReferenceId &&
                        this.renderFieldColumn(
                            'col-lg-3 col-md-4',
                            getPriceListName(this.props.intl),
                            <Link to={`/price-lists/${this.state.order.attributes.priceListReferenceId}/edit`}>
                                {this.state.order.attributes.priceListReferenceLabel}</Link>,
                        )}
                    {this.state.quotes.length > 0 && this.renderFieldColumn(
                        'col-lg-3 col-md-4',
                        <FormattedMessage
                            id="order.analytics.quote_reference_label"
                            defaultMessage="Quote ordered"
                        />,
                        this.state.quotes.map(quo => {
                            return <p key={quo.id} className={'mb-0'}>
                                <Link to={'/quotes/' + quo.id + '/edit'}>
                                    {quo.identifier}
                                </Link>
                            </p>
                        }),
                    )}
                    {this.state.invoices.length > 0 && this.renderFieldColumn(
                        'col-lg-3 col-md-4',
                        <FormattedMessage
                            id="order.analytics.invoice_reference_label"
                            defaultMessage="Invoices"
                        />,
                        this.state.invoices.map(inv => {
                            return <p key={inv.id} className={'mb-0'}>
                                <Link to={'/invoices/' + inv.id + '/edit'}>
                                    {inv.identifier}
                                </Link>
                            </p>
                        }),
                    )}
                    {this.state.externalPurchaseOrders.length > 0 && this.renderFieldColumn(
                        'col-lg-3 col-md-4',
                        <FormattedMessage
                            id="order.analytics.purchase_order_label"
                            defaultMessage="Purchase order"
                        />,
                        this.state.externalPurchaseOrders.map(po => {
                            return <p key={po.id} className={'mb-0'}>
                                <a href={Integrations.getExternalPurchaseOrderUrl(po)} target={'_blank'}>
                                    #{Integrations.getShortenedPONumber(po)}
                                </a>
                            </p>
                        }),
                    )}
                    {
                        <CustomFieldRendering
                            col={0}
                            customFieldValues={this.state.customFieldValues}
                            customFieldDefinitions={this.state.customFieldDefinitions}
                            isEditable={this.state.isEditable}
                            elementId={this.state.project?.id}
                            changeCustomFieldValues={this.changeCustomFieldValues}
                        />
                    }
                </div>
            ]
        } else if (this.state.invoice) {
            return [
                <div className="w-100 d-flex flex-wrap" key={0}>
                    {!this.isReturn() &&
                        <EditProjectTitleComponent
                            editable={this.state.isEditable}
                            endPoint={'/projects/' + this.state.project?.id}
                            field={'title'}
                            value={this.state.invoice.attributes.project.attributes.title}
                            onSave={value => {
                                let invoice = Object.assign({}, this.state.invoice)
                                invoice.attributes.project.attributes.title = value
                                this.setState({invoice})
                            }}
                        />
                    }
                    {!this.isReturn() && (this.state.invoice.attributes.poNumber || this.state.isEditable) &&
                        this.renderFieldColumn(
                            'col-lg-3 col-md-4',
                            <FormattedMessage
                                id="quote.analytics.po_number_label"
                                defaultMessage="PO Number"
                            />,
                            <InlineEditText
                                editable={this.state.isEditable}
                                endPoint={'/invoices/' + this.state.invoice.id}
                                field={'poNumber'}
                                value={this.state.invoice.attributes.poNumber}
                                onSave={value => {
                                    let invoice = Object.assign({}, this.state.invoice)
                                    invoice.attributes.poNumber = value
                                    this.setState({invoice})
                                }}
                            />
                        )
                    }
                    {this.state.invoice.attributes.debtCreditMemoID && this.state.debtCreditMemo &&
                        this.renderFieldColumn(
                            'col-lg-3 col-md-4',
                            <FormattedMessage
                                id="quote.analytics.deb_credit_memo_label"
                                defaultMessage="Debt for Credit Memo"
                            />,
                            < CreditMemoModalLink
                                creditMemoId={this.state.debtCreditMemo.id}
                                creditMemoIdentifier={this.state.debtCreditMemo.attributes.identifier}
                                contactId={this.state.debtCreditMemo.attributes.contactId}/>
                        )
                    }

                    {(this.state.invoice.attributes.dueDate && this.state.invoice.attributes.billingType === BILLING_TYPE.ONETIME) &&
                        this.renderFieldColumn(
                            'col-lg-3 col-md-4',
                            <FormattedMessage
                                id="invoice.edit.invoice_details.due_date_label"
                                defaultMessage="Due date"
                            />,
                            <InvoiceDueDate
                                value={this.state.invoice.attributes.dueDate}
                                invoiceId={this.state.invoice.id}
                                editable={this.state.isEditable}
                                status={this.state.invoice.attributes.status}
                                onSave={value => {
                                    let invoice = Object.assign({}, this.state.invoice)
                                    invoice.attributes.dueDate = value
                                    this.setState({invoice})
                                    this.refreshObject(this.state.invoice.id)
                                }}
                            />
                        )
                    }

                    {!this.isReturn() &&
                        this.renderFieldColumn(
                            'col-lg-3 col-md-4',
                            <FormattedMessage
                                id="invoice.edit.invoice_details.payment_term_label"
                                defaultMessage="Payment term"
                            />,
                            <InvoicePaymentTerm
                                value={this.state.invoice.attributes.paymentTerm ? this.state.invoice.attributes.paymentTerm.attributes.name : ''}
                                paymentTermId={this.state.invoice.attributes.paymentTerm ? this.state.invoice.attributes.paymentTerm.id : ''}
                                invoiceId={this.state.invoice.id}
                                editable={this.state.isEditable}
                                onChange={(paymentTermName, dueDate) => {
                                    let invoice = Object.assign({}, this.state.invoice)
                                    let paymentTerm = this.state.invoice.attributes.paymentTerm
                                    if (!paymentTerm) {
                                        paymentTerm = {
                                            attributes: {
                                                name: paymentTermName
                                            }
                                        }
                                    }
                                    invoice.attributes.paymentTerm = paymentTerm
                                    invoice.attributes.dueDate = dueDate
                                    this.setState({invoice})
                                }}
                            />
                        )
                    }
                    {(!this.isRecurringInvoice() && !this.isReturn()) &&
                        this.renderFieldColumn(
                            'col-lg-3 col-md-4',
                            <FormattedMessage
                                id="invoice.edit.invoice_details.sent_date_label"
                                defaultMessage="Sent date"
                            />,
                            <InlineEditDate
                                value={this.state.invoice.attributes.sentAt}
                                endPoint={'/invoices/' + this.state.invoice.id}
                                field={'sentAt'}
                                editable={this.state.isEditable}
                                futureDatesDisabled={true}
                                onSave={value => {
                                    let invoice = Object.assign({}, this.state.invoice)
                                    invoice.attributes.sentAt = value
                                    this.setState({invoice})
                                }}
                            />
                        )
                    }
                    {this.state.priceListReference &&
                        this.renderFieldColumn(
                            'col-lg-3 col-md-4',
                            <FormattedMessage
                                id="order.analytics.order_price_list_label"
                                defaultMessage="Price list"
                            />,
                            <Link to={`/price-lists/${this.state.priceListReference.id}/edit`}>
                                {this.state.priceListReference.attributes.identifier}</Link>,
                        )}
                    {this.isReturn() && this.state.invoice.attributes.fullyPaidAt ?
                        this.renderFieldColumn(
                            'col-lg-3 col-md-4',
                            <FormattedMessage
                                id="invoice.edit.invoice_details.paid_date_label"
                                defaultMessage="Paid date"
                            />,
                            <InvoiceDueDate
                                value={this.state.invoice.attributes.fullyPaidAt}
                                status={this.state.invoice.attributes.status}
                                invoiceId={this.state.invoice.id}
                                editable={this.state.isEditable}
                                onSave={value => {
                                    let invoice = Object.assign({}, this.state.invoice)
                                    invoice.attributes.fullyPaidAt = value
                                    this.setState({invoice})
                                }}
                            />
                        ) : ''}

                    {this.state.quoteReference && !this.isReturn() ?
                        this.renderFieldColumn(
                            'col-lg-3 col-md-4',
                            <FormattedMessage
                                id="invoice.edit.invoice_details.quote_reference_label"
                                defaultMessage="Quote invoiced"
                            />,
                            <Link to={'/quotes/' + this.state.quoteReference.id + '/edit'}>
                                {this.state.quoteReference.attributes.identifier}
                            </Link>
                        ) : ''}

                    {this.state.invoice.attributes.externalOrders.length > 0 ?
                        this.renderFieldColumn(
                            'col-lg-3 col-md-4',
                            <FormattedMessage
                                id="invoice.edit.invoice_details.order_label"
                                defaultMessage="Order invoiced"
                            />,
                            this.state.invoice.attributes.externalOrders.map(order => {
                                return <div key={order.attributes.externalId} className="pl-0 col-12">
                                    <a href={Integrations.getExternalOrderUrl(order)}>
                                        #{order.attributes.externalId}
                                    </a>
                                </div>
                            })
                        ) : ''}

                    {this.state.orderReference ?
                        this.renderFieldColumn(
                            'col-lg-3 col-md-4',
                            <FormattedMessage
                                id="invoice.edit.invoice_details.order_label"
                                defaultMessage="Order invoiced"
                            />,
                            <div className="pl-0 col-12">
                                <Link to={'/orders/' + this.state.orderReference.id + '/edit'}>
                                    {this.state.orderReference.attributes.identifier}
                                </Link>
                            </div>,
                        ) : ''}

                    {this.state.recurringInvoice ?
                        this.renderFieldColumn(
                            'col-lg-3 col-md-4',
                            <FormattedMessage
                                id="invoice.edit.invoice_details.recurring_invoice_label"
                                defaultMessage="Created from recurring invoice"
                            />,
                            <a href={'#'} onClick={this.loadAnotherInvoice(this.state.recurringInvoice.id)}>
                                {this.state.recurringInvoice.attributes.identifier}
                            </a>
                        ) : ''}

                    {this.state.relatedInvoice ?
                        this.renderFieldColumn(
                            'col-lg-3 col-md-4',
                            <FormattedMessage
                                id="invoice.edit.invoice_details.existing_invoice_label"
                                defaultMessage="Return from invoice"
                            />,
                            <a href={'#'} onClick={this.loadAnotherInvoice(this.state.relatedInvoice.id)}>
                                {this.state.relatedInvoice.attributes.identifier}
                            </a>
                        ) : ''}

                    {
                        <CustomFieldRendering
                            col={0}
                            customFieldValues={this.state.customFieldValues}
                            customFieldDefinitions={this.state.customFieldDefinitions}
                            isEditable={this.state.isEditable}
                            elementId={this.state.project?.id}
                            changeCustomFieldValues={this.changeCustomFieldValues}
                        />
                    }
                </div>,
            ]
        }
        if (this.props.stockDocument) {
            return [
                this.renderFieldColumn(
                    'col-lg-3 col-md-4',
                    <FormattedMessage
                        id="invoice.edit.invoice_details.sent_date_label"
                        defaultMessage="Sent date"
                    />,
                    <InlineEditDate
                        value={this.props.stockDocument.sentAt}
                        endPoint={'/stock-documents/' + this.props.stockDocument.id}
                        field={'sentAt'}
                        editable={this.props.isEditable}
                        futureDatesDisabled={true}
                    />
                ),
                this.props.stockDocument.references?.length > 0 && this.renderFieldColumn(
                    'col-lg-3 col-md-4',
                    <FormattedMessage
                        id="project.form.edit.reference_label"
                        defaultMessage="Reference"
                    />,
                    this.props.stockDocument.references.map(ref => {
                        return <p key={ref.id} className={'mb-0'}>
                            <Link to={`/${ref.attributes.referenceKey}/${ref.attributes.referenceId}/edit`}>
                                {ref.attributes.referenceIdentifier}
                            </Link>
                        </p>
                    }),
                ),
                <CustomFieldRendering
                    col={0}
                    customFieldValues={this.state.customFieldValues}
                    customFieldDefinitions={this.state.customFieldDefinitions}
                    isEditable={this.state.isEditable}
                    elementId={this.state.project?.id}
                    changeCustomFieldValues={this.changeCustomFieldValues}
                />

            ]
        }
    }

    getDocument() {
        if (this.state.invoice) {
            return "invoices"
        }
        if (this.state.quote) {
            return "quotes"
        }
        if (this.state.order) {
            return "orders"
        }
    }

    getDocumentId() {
        if (this.state.invoice) {
            return this.state.invoice.id
        }
        if (this.state.quote) {
            return this.state.quote.id
        }
        if (this.state.order) {
            return this.state.order.id
        }
    }

    getUserId() {
        if (this.state.invoice) {
            return this.state.invoice.attributes.sellerId
        }
        if (this.state.order) {
            return this.state.order.attributes.sellerId
        }
        return this.state.project.attributes.assignedToUserId
    }

    getIdentifier() {
        if (this.state.invoice) {
            return this.state.invoice.attributes.identifier
        }
        if (this.state.quote) {
            return this.state.quote.attributes.identifier
        }
        if (this.state.order) {
            return this.state.order.attributes.identifier
        }
        return ''
    }

    getInlineEditAddressEndPoint() {
        if (this.state.invoice) {
            return '/invoices/' + this.state.invoice.id
        }

        if (this.state.order) {
            return '/orders/' + this.state.order.id
        }

        if (this.state.quote) {
            return '/quotes/' + this.state.quote.id
        }

        return '/projects/' + this.state.project.id
    }

    getInlineEditUser() {
        if (this.state.invoice) {
            return <InlineEditUser
                editable={this.state.isEditable}
                endPoint={'/invoices/' + this.state.invoice.id}
                field={'sellerId'}
                value={this.state.invoice.attributes.seller.attributes.name}
                userId={this.state.invoice.attributes.sellerId}
                onSave={(state) => this.onSaveInLineUser('invoice', state)}
            />
        }
        if (this.state.order) {
            return <InlineEditUser
                editable={this.state.isEditable}
                endPoint={'/orders/' + this.state.order.id}
                field={'sellerId'}
                value={this.state.order.attributes.seller.attributes.name}
                userId={this.state.order.attributes.sellerId}
                onSave={(state) => this.onSaveInLineUser('order', state)}
            />
        }

        return <InlineEditUser
            editable={this.state.isEditable}
            endPoint={'/projects/' + this.state.project?.id}
            field={'assignToUserId'}
            value={this.state.project?.attributes.assignedToUser?.attributes.name ?? ""}
            userId={this.state.project?.attributes.assignedToUser?.id ?? ""}
            onSave={(state) => this.onSaveInLineUser('project', state)}
        />
    }

    getLocation() {
        if (this.state.invoice) {
            return this.state.invoice.attributes.location
        }
        if (this.state.order) {
            return this.state.order.attributes.location
        }
        if (this.state.quote) {
            return this.state.project.attributes.location
        }
        return this.state.project.attributes.location
    }

    getInlineEditLocation(locationEditable) {
        if (AppContext.getUserLoggedIn().attributes.superUser) {
            locationEditable = true
        }

        if (this.state.invoice) {
            return <InlineEditLocation
                editable={GlobalHelper.hasAccessToAllLocations() && this.state.isEditable && locationEditable}
                endPoint={'/invoices/' + this.state.invoice.id}
                value={this.state.invoice.attributes.location ? this.state.invoice.attributes.location.attributes.name : ''}
                locationId={this.state.invoice.attributes.locationId}
                onSave={(state) => {
                    this.refreshObject(this.state.invoice.id)
                }}
            />
        }
        if (this.state.order) {
            return <InlineEditLocation
                editable={GlobalHelper.hasAccessToAllLocations() && this.state.isEditable && locationEditable}
                endPoint={'/orders/' + this.state.order.id}
                value={this.state.order.attributes.location ? this.state.order.attributes.location.attributes.name : ''}
                locationId={this.state.order.attributes.locationId}
                onSave={(state) => {
                    this.refreshObject(this.state.order.id)
                }}
            />
        }
        if (this.state.quote) {
            return <InlineEditLocation
                editable={GlobalHelper.hasAccessToAllLocations() && this.state.isEditable && locationEditable}
                endPoint={'/projects/' + this.state.project?.id}
                value={this.state.project?.attributes.location?.attributes.name ?? ''}
                locationId={this.state.project?.attributes.locationId}
                onSave={(state) => {
                    this.refreshObject(this.state.quote.id)
                }}
            />
        }
        if (this.props.stockDocument) {
            return <label>{this.props.stockDocument.stockLocation?.attributes.name}</label>
        }

        return <InlineEditLocation
            editable={GlobalHelper.hasAccessToAllLocations() && this.state.isEditable && locationEditable}
            endPoint={'/projects/' + this.state.project?.id}
            value={this.state.project?.attributes.attributes?.location.attributes.name ?? ''}
            locationId={this.state.project?.attributes.locationId}
            onSave={(state) => {
                this.onSaveInLineLocation('project', state)
            }}
        />
    }

    getDocumentReferences() {
        if (this.state.invoice) {
            return [
                this.state.invoice.attributes.quoteReferenceId,
                this.state.invoice.attributes.orderReferenceId,
            ]
        }
        if (this.state.quote) {
            return [
                '',
                this.state.quote.attributes.orderReferenceId,
            ]
        }
        if (this.state.order) {
            return [
                this.state.order.attributes.quoteReferenceId,
                '',
            ]
        }
        return [
            '',
            '',
        ]
    }

    render() {
        if (!this.state.project) {
            return <LoadingSpinner />
        }
        
        const contact = this.state.contact
        let contactPrimaryPhoneNumber = ''
        let contactPrimaryPhoneNumberExtension = ''

        if (contact) {
            for (let i = 0; i < contact.attributes.phoneNumbers.length; i++) {
                if (contact.attributes.phoneNumbers[i]["type"] === "primary") {
                    contactPrimaryPhoneNumber = contact.attributes.phoneNumbers[i]["phoneNumber"]
                    contactPrimaryPhoneNumberExtension = contact.attributes.phoneNumbers[i]["extension"]
                }
            }
        }


        let locationEditable = true
        if (this.state.invoice && this.state.invoice.attributes.status !== 'draft' && this.state.invoice.attributes.externalLinks.length > 0) {
            locationEditable = false
        }
        if (this.state.order && this.state.order.attributes.status !== 'draft' && this.state.order.attributes.externalLinks.length > 0) {
            locationEditable = false
        } else if (this.state.order && this.state.order.attributes.status !== 'draft') {
            for (let item of this.state.order.attributes.items) {
                if (parseFloat(item.attributes.inventoryReservedMeasure) > 0) {
                    locationEditable = false
                    break
                }
            }
        }

        const billingAddress = this.state.project?.attributes?.address ?? {}
        const shippingAddress = this.state.project?.attributes?.shippingAddress ?? {}
        const documentType = this.getDocument()
        const documentId = this.getDocumentId()
        return <div className={"row ui-module"}>
            <div className={'col-lg-6 col-md-12 pl-md-3 pr-md-0 pr-lg-3 ' +
                (['lg', 'xl'].includes(GlobalHelper.getResponsiveBreakpoint()) ? 'border-right' : '')}>
                <div className={"row mb-md-3"}>
                    <div className="col-12 pl-0 pr-md-0 pl-lg-1">
                        <h3 className={'m-0 d-flex align-items-center'}>
                            {
                                this.state.invoice &&
                                [
                                    !this.isReturn() ? <FormattedMessage
                                        id="invoice.analytics.title_label"
                                        defaultMessage="Invoice {number}"
                                        values={{
                                            number: this.state.invoice.attributes.identifier
                                        }}
                                    /> : <FormattedMessage
                                        id="invoice.analytics.return_title_label"
                                        defaultMessage="Return {number}"
                                        values={{
                                            number: this.state.invoice.attributes.identifier
                                        }}
                                    />,
                                    <h6 className="ml-2 d-inline mb-0">
                                        <InvoiceStatusBadge
                                            status={this.state.invoice.attributes.status}
                                        />
                                    </h6>
                                ]
                            }
                            {
                                this.state.order &&
                                [
                                    < FormattedMessage
                                        id="order.analytics.title_label"
                                        defaultMessage="Order {number}"
                                        values={{
                                            number: this.state.order.attributes.identifier
                                        }}
                                    />,
                                    <h6 className="ml-2 d-inline mb-0">
                                        <OrderStatusBadge statusId={this.state.order.attributes.customStatusId}/>
                                    </h6>
                                ]
                            }
                            {
                                this.state.quote &&
                                [
                                    <InlineEditText
                                        editable={this.state.isEditable}
                                        endPoint={'/projects/' + this.state.project.id}
                                        field={'title'}
                                        value={this.state.project.attributes.title}
                                        onSave={value => {
                                            let project = Object.assign({}, this.state.project)
                                            project.attributes.title = value
                                            this.setState({project})
                                        }}
                                    />,
                                    <h6 className="ml-2 d-inline mb-0">
                                        <QuoteStatusBadge
                                            status={this.state.quote.attributes.status}
                                        />
                                    </h6>
                                ]
                            }
                            {this.props.stockDocument &&
                                [
                                    this.props.stockDocument.identifier,
                                    <h6 className="ml-2 d-inline mb-0">
                                        <StatusBadge
                                            colorCode={this.props.stockDocument.status.attributes.colorCode}
                                            text={this.props.stockDocument.status.attributes.name}
                                        />
                                    </h6>
                                ]
                            }
                        </h3>
                    </div>
                    <div className="col-12 pl-0 flex-wrap d-flex align-items-start">
                        {this.renderFieldsByDocumentType()}
                        {
                            AppContext.accountFeatureIsEnabled(AccountFeatures.FeatureScheduling) &&
                            this.state.project.attributes.documentType !== STOCK_DOCUMENTS &&
                            this.renderFieldColumn(
                                'col-lg-12 col-md-12',
                                '',
                                <InlineEditAgenda
                                    editable={this.state.isEditable}
                                    documentType={documentType}
                                    documentId={documentId}
                                    invoiceId={this.state.invoice ? this.state.invoice.id : ''}
                                    quoteId={this.state.quote ? this.state.quote.id : ''}
                                    orderId={this.state.order ? this.state.order.id : ''}
                                    contactId={this.state.contactId}
                                    userId={this.getUserId()}
                                    projectId={this.state.project.id}
                                    project={this.state.project}
                                    identifier={this.getIdentifier()}
                                    quoteReferenceId={this.getDocumentReferences()[0]}
                                    orderReferenceId={this.getDocumentReferences()[1]}
                                    proposal={this.props.proposal}
                                    location={this.getLocation()}
                                />
                            )
                        }
                    </div>
                </div>
            </div>
            <div className="col-lg-6 col-md-12">
                <div className="row mb-2 pl-lg-3 pr-lg-1 pl-md-0 d-flex justify-content-between">
                    {!contact ? <></> :
                        this.state.showProjectCustomerEditForm ?
                            <div className={'flex-grow-1 w-100 pl-lg-0 pl-md-1'}>
                                <ProjectCustomerEditForm
                                    className="px-3"
                                    initialContactId={this.state.initialContactId}
                                    value={this.state.contactId}
                                    isEditable={this.state.isEditable}
                                    onChange={this.handleCustomerChanged}
                                />
                            </div> : <div className={'flex-grow-1 w-50 mw-50 pl-lg-0 pl-md-2'}>
                                <h4 className={'m-0 mt-1'}>
                                    <strong>
                                        {contact.type === "suppliers" ?
                                            <Link to={'/suppliers/' + contact.id + '/details'}>
                                                {contact.attributes.name}
                                            </Link> :
                                            <Link to={'/contacts/' + contact.id + '/details'}>
                                                {contact.attributes.name}
                                            </Link>
                                        }
                                    </strong>
                                    {contact.type === 'persons' && contact.attributes.organizationId ?
                                        <small className={'ml-2'}>
                                            <small>
                                                <Link to={'/contacts/' + contact.attributes.organizationId + '/details'}>
                                                    <Icon value={'building'}/> {contact.attributes.organizationName}
                                                </Link>
                                            </small>
                                        </small> : null}
                                </h4>
                                <p className={'m-0'}>
                                    <a href={'mailto:' + contact.attributes.email}>
                                        {contact.attributes.email}
                                    </a>
                                    {!GlobalHelper.validateEmail(contact.attributes.email) && <div className="text-danger">
                                        <small>
                                            <Icon value={'exclamation'} className={'mr-1'}/>
                                            <FormattedMessage
                                                id="customer.view.email_invalid"
                                                defaultMessage="Contact's email is invalid."
                                            />
                                        </small>
                                    </div>
                                    }
                                </p>
                                {contactPrimaryPhoneNumber && <p className={'m-0'}>
                                        <a href={'tel:' + contactPrimaryPhoneNumber + "," + contactPrimaryPhoneNumberExtension}>
                                            {GlobalHelper.formatPhoneNumber(contactPrimaryPhoneNumber, contact.attributes.address.countryCode) + contactPrimaryPhoneNumberExtension}
                                        </a>
                                    </p>
                                }

                                {this.state.showLoyaltyBalance && this.state.loyaltyBalance &&
                                    <div className="mb-0">
                                        <label
                                            className="col-12 col-form-label custom-form-label project-details-label pt-2 pl-0">
                                            <FormattedMessage
                                                id="quote.edit.project.customer.points_balance_label"
                                                defaultMessage="Points balance"
                                            />
                                        </label>

                                        <pre><FormattedNumber value={this.state.loyaltyBalance}/></pre>
                                    </div>
                                }

                                {contact.attributes.notes &&
                                    <div className="mb-0 d-flex">
                                        <Icon value={'sticky-note'} className={'mr-1'}/>
                                        <span>
                                                <pre className="d-inline" style={{whiteSpace: 'pre-wrap'}}>
                                                    {contact.attributes.notes}
                                                </pre>
                                            </span>
                                    </div>
                                }

                                {this.state.isEditable && !this.props.stockDocument &&
                                    <div className="mt-2">
                                        <p className="text-align-left">
                                            <a href="#" onClick={(e) => {
                                                e.preventDefault()
                                                this.setState({
                                                    showProjectCustomerEditForm: true,
                                                })
                                            }} className="btn btn-outline-primary btn-sm">
                                                <Icon value={'retweet'} className={'mr-1'}/>
                                                <FormattedMessage
                                                    id="quote.edit.project.customer.change_btn"
                                                    defaultMessage="Change"
                                                />
                                            </a>
                                        </p>
                                    </div>
                                }
                            </div>
                    }


                    <div className={'flex-grow-1 text-right w-50 mw-50 pr-lg-0 pr-md-2'}>
                        <div className={'w-100'}>
                            <label className="col-form-label custom-form-label project-details-label pt-0">
                                <strong>
                                    <FormattedMessage
                                        id="quote.analytics.assign_to_label"
                                        defaultMessage="Assigned to"
                                    />
                                </strong>
                            </label>
                        </div>
                        <p className={'m-0 position-relative'}>
                            <Icon value={'user'}/>
                            {this.getInlineEditUser()}
                        </p>
                        <div className={'w-100'}>
                            <label className="col-form-label custom-form-label project-details-label pt-2">
                                <strong>
                                    {this.props.stockDocument ?
                                        <FormattedMessage
                                            id="quote.analytics.stock_location_label"
                                            defaultMessage="Stock Location"
                                        /> :
                                        <FormattedMessage
                                            id="quote.analytics.location_label"
                                            defaultMessage="Location"
                                        />
                                    }
                                </strong>
                            </label>
                        </div>
                        <p className={'m-0 position-relative'}>
                            <Icon value={'map-marker-alt'}/>
                            {this.props.stockDocument ?
                                this.props.stockDocument.inventoryLocation?.attributes.name :
                                this.getInlineEditLocation(locationEditable)
                            }
                        </p>
                    </div>
                </div>
                {contact &&
                    <div className="row pl-lg-3 pl-md-0">
                        <div className="col-6 pr-0 pl-lg-1 pl-md-0 mb-3">
                            <div className={'w-100 text-left pl-lg-0 pl-md-2'}>
                                <div className={'w-100'}>
                                    <label className="col-form-label custom-form-label project-details-label pt-2">
                                        <strong>
                                            <FormattedMessage
                                                id="project.form.edit.billing_address_label"
                                                defaultMessage="Billing address"
                                            />
                                        </strong>
                                    </label>
                                </div>

                                <div className={'w-100'}>
                                    <InlineEditAddress
                                        endPoint={this.getInlineEditAddressEndPoint()}
                                        addressEndPoint={'/projects/' + this.state.project.id}
                                        field={'address'}
                                        style={{right: '0', left: 'auto'}}
                                        editable={this.state.isEditable}
                                        objectType={'project'}
                                        formId={'quote-billing-address'}
                                        address={billingAddress}
                                        organizationId={contact.attributes.organizationId || ''}
                                        contactId={this.state.contactId}
                                        addressType={'billing'}
                                        contactType={contact.type}
                                        contactAddresses={contact.attributes.addresses}
                                        onSave={(state) => {
                                            this.onSaveInlineAddress(state)
                                            let project = Object.assign({}, this.state.project)
                                            project.attributes.address = state.address
                                            this.setState({
                                                project,
                                            })
                                            this.refreshObject(this.getDocumentId())
                                        }}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="col-6 pr-0 pr-lg-1 mb-3">
                            <div className={'w-100 text-right pr-lg-0 pr-md-2'}>
                                <div className={'w-100'}>
                                    <label className="col-form-label custom-form-label project-details-label pt-2">
                                        <strong>
                                            <FormattedMessage
                                                id="project.form.edit.shipping_address_label"
                                                defaultMessage="Shipping address"
                                            />
                                        </strong>
                                    </label>
                                </div>
                                <div className={'w-100'}>
                                    <InlineEditAddress
                                        endPoint={this.getInlineEditAddressEndPoint()}
                                        addressEndPoint={'/projects/' + this.state.project.id}
                                        field={'shippingAddress'}
                                        style={{right: '0', left: 'auto'}}
                                        editable={this.state.isEditable}
                                        objectType={'project'}
                                        formId={'quote-shipping-address'}
                                        address={shippingAddress}
                                        organizationId={contact.attributes.organizationId || ''}
                                        contactId={this.state.contactId}
                                        addressType={'shipping'}
                                        contactType={contact.type}
                                        contactAddresses={contact.attributes.addresses}
                                        onSave={(state) => {
                                            this.onSaveInlineAddress(state)
                                            let project = Object.assign({}, this.state.project)
                                            project.attributes.shippingAddress = state.address
                                            this.setState({
                                                project,
                                            })
                                            this.refreshObject(this.getDocumentId())
                                        }}
                                    />
                                </div>
                            </div>
                        </div>
                        <CustomFieldRendering
                            col={1}
                            customFieldValues={this.state.customFieldValues}
                            customFieldDefinitions={this.state.customFieldDefinitions}
                            isEditable={this.state.isEditable}
                            elementId={this.state.project.id}
                            changeCustomFieldValues={this.changeCustomFieldValues}
                        />
                    </div>
                }
            </div>
        </div>
    }
}

export default injectIntl(ProjectDetailsEditForm)





// WEBPACK FOOTER //
// ./src/quote/project/details.component.jsx